module.exports = __webpack_public_path__ + "h5/img/noShopper.361ffa17.png";